import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Typography, Card } from 'antd'
import { styles } from './styles'


import { compose, withProps } from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle,
  InfoWindow
} from 'react-google-maps'
import _ from 'lodash'


import { GOOGLE_MAP_API_URL, DEFAULT_LOCATION, HeroType } from '../../../../config'

export const HeroLocations = ({ locations }) => {
  console.log(locations)
  const [open, setOpen] = useState(false)
  return (
    // <GoogleMap
    //   defaultZoom={10}
    //   center={{ lat: 18.786998118908446, lng: 98.98629409697264 }}
    // >
    //   {locations &&
    //     locations.map((map, index) => (
    //       <div key={index.toString()}>
    //         <Marker
    //           title={map.name}
    //           position={{
    //             lat: parseFloat(map.lat),
    //             lng: parseFloat(map.lng)
    //           }}
    //         />
    //         <Circle
    //           options={{
    //             strokeColor: 'transparent',
    //             fillColor: 'green',
    //             fillOpacity: 0.1
    //           }}
    //           center={{ lat: parseFloat(map.lat), lng: parseFloat(map.lng) }}
    //           radius={map.radius}
    //         />
    //       </div>
    //     ))}
    // </GoogleMap>

    <GoogleMap defaultZoom={10} center={DEFAULT_LOCATION}>
      {!_.isEmpty(locations) &&
        locations.map((location, index) => (
          <div key={index.toString()}>
            <Marker
              position={{
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude)
              }}
              onClick={() => {
                setOpen(location.id)
              }}
              icon={new window.google.maps.MarkerImage(
                location.icon,
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new window.google.maps.Size(22, 32)
              )}>
              {open === location.id && (
                <InfoWindow onCloseClick={() => setOpen(false)}>
                  <Card square style={{ width: 400 }}>
                    <div style={styles.productWraper}>
                      <Typography gutterBottom variant="h5" component="h5">
                        {`${location.name} (${HeroType[location.heroType] ? HeroType[location.heroType].title : '-'
                          })`}
                      </Typography>
                    </div>
                    {/* <Typography variant="body1" component="p" gutterBottom> */}
                    {/*  {location.address} */}
                    {/* </Typography> */}

                    {/* <Typography>วัสดุที่รับ:</Typography> */}

                    {/* <div style={styles.productWraper}> */}
                    {/*  {location.hero.products.map((product, index) => ( */}
                    {/*    <Typography key={product.id}> */}
                    {/*      {index > 0 && ','} */}
                    {/*      {product.material.name} */}
                    {/*    </Typography> */}
                    {/*  ))} */}
                    {/* </div> */}
                  </Card>
                </InfoWindow>
              )}
            </Marker>
            {/* <Circle
            options={{
              strokeColor: 'transparent',
              fillColor: location.user ? 'red' : 'green',
              fillOpacity: 0.2
            }}
            center={{
              lat: parseFloat(location.latitude),
              lng: parseFloat(location.longitude)
            }}
            radius={location.radius}
          /> */}
          </div>
        ))}
    </GoogleMap>
  )
}

HeroLocations.propTypes = {
  locations: PropTypes.array.isRequired
}

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_API_URL,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `50vh` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(HeroLocations)



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroLocations/index.js